var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSriLanka(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "SRI_LANKA_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000132776592262306242840000015340453461741638303_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000132776592262306242840000015340453461741638303__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.8015 2.71875H7.10449V18.1917H12.8015V2.71875Z",
    fill: "#ED6F22"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000132776592262306242840000015340453461741638303__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M7.11113 2.71875H1.49414V18.1948H7.11113V2.71875Z",
    fill: "#2F742E"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000132776592262306242840000015340453461741638303__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M32.087 2.71875H14.29V18.1948H32.087V2.71875Z",
    fill: "#8E1841"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000132776592262306242840000015340453461741638303__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M21.0762 9.90182L21.3702 9.90982C21.3702 9.90982 21.0402 10.1908 21.1152 10.5658C21.4612 10.0538 21.5882 10.1518 21.5882 10.1518C21.4832 10.2648 21.2812 10.4248 21.4382 10.7688C21.5742 10.4168 21.8512 10.1438 21.8512 10.1438C21.8512 10.1438 21.7772 10.5348 21.9422 10.8978C22.0612 10.5348 22.2662 10.2298 22.2662 10.2298C22.2662 10.2298 22.2372 10.6168 22.4082 10.7608C22.5462 10.6398 22.6352 10.3308 22.6352 10.3308C22.6352 10.3308 22.8912 10.7838 23.0482 10.8508C23.1752 10.5458 23.1752 10.3038 23.1752 10.3038C23.1752 10.3038 23.7022 10.6788 24.1252 10.4598C23.7482 10.3228 23.6212 10.0068 23.6212 10.0068C23.6212 10.0068 24.3042 10.3078 24.5982 10.1748C24.3142 9.9558 23.6432 9.63181 23.6432 9.63181C23.6432 9.63181 24.1382 9.81583 24.2832 9.76883C24.2152 9.67083 23.9972 9.5498 23.9972 9.5498L21.0762 9.90182Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M21.9576 10.9024C21.7826 10.5864 21.8196 10.2424 21.8316 10.1604C21.7956 10.2304 21.5686 10.4764 21.4546 10.7774C21.2736 10.4494 21.4366 10.2814 21.5436 10.1724L21.5686 10.1494C21.5396 10.1614 21.4086 10.1614 21.1286 10.5794C21.0206 10.1884 21.3556 9.89942 21.3586 9.89542L21.0756 9.92642C21.0646 9.92642 21.0596 9.91444 21.0596 9.90344C21.0596 9.89544 21.0666 9.88342 21.0756 9.88742L21.3696 9.89542C21.3786 9.93042 21.0596 10.2044 21.1326 10.5634C21.3226 10.2274 21.4606 10.1414 21.5346 10.1334C21.5766 10.1254 21.5956 10.1334 21.5976 10.1374L21.5686 10.1964C21.4626 10.3094 21.3136 10.4624 21.4536 10.7624C21.5566 10.4104 21.8336 10.1334 21.8376 10.1334C21.8666 10.1534 21.7956 10.5394 21.9576 10.8874C22.0446 10.5324 22.2496 10.2234 22.2506 10.2194C22.2816 10.2314 22.2546 10.6144 22.4196 10.7504C22.5256 10.6334 22.6146 10.3324 22.6146 10.3284C22.6516 10.3324 22.9036 10.7694 23.0546 10.8364C23.1546 10.5474 23.1566 10.3094 23.1566 10.3054C23.1716 10.2974 23.4976 10.5084 23.8276 10.5084C23.9236 10.5084 24.0236 10.4924 24.1136 10.4454C23.7366 10.3404 23.6066 10.0314 23.6006 10.0154C23.6236 10.0034 24.0806 10.1914 24.4006 10.1914C24.4706 10.1914 24.5386 10.1794 24.5876 10.1604C24.3046 9.97643 23.6396 9.65243 23.6346 9.65243C23.6486 9.62543 24.0386 9.75742 24.2196 9.75742C24.2426 9.75742 24.2616 9.75742 24.2766 9.75342C24.2016 9.68342 23.9896 9.56943 23.9866 9.56543C24.0146 9.54243 24.2266 9.65944 24.2966 9.75644C24.1936 9.80744 23.9446 9.74842 23.7836 9.69742C24.0006 9.79142 24.4026 10.0024 24.6076 10.1584C24.3266 10.3144 23.7246 10.0724 23.6256 10.0294C23.6716 10.0724 23.8096 10.3264 24.1296 10.4394C23.7276 10.6854 23.2396 10.3694 23.1726 10.3224C23.1936 10.3574 23.1806 10.5804 23.0656 10.8574C22.8906 10.7984 22.6616 10.4124 22.6236 10.3494C22.6326 10.4004 22.5456 10.6624 22.4206 10.7754C22.2486 10.6464 22.2446 10.3414 22.2466 10.2524C22.2166 10.3364 22.0576 10.6024 21.9576 10.9024Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M25.1839 6.2338C26.0919 6.1518 27.4939 6.8938 28.2349 7.3898C28.2349 7.2218 28.2349 7.0578 28.4019 6.9758C28.5649 6.8938 28.8129 7.0578 28.7319 7.3078C28.4839 7.8818 27.4939 7.2218 27.1639 7.0578L27.3289 7.3898C26.8349 7.3078 26.7529 7.2218 26.4229 6.8118C26.3399 7.1398 26.3399 7.22177 25.9269 7.22177C26.0839 6.97577 26.1349 6.8938 25.9269 6.6478L25.8449 7.1398L25.4359 6.5658V7.1398C25.3499 7.0578 25.0209 6.8118 24.8559 6.8118C24.6089 6.7298 24.4439 7.22178 24.3609 7.46778C24.6089 7.22178 24.6909 7.05777 25.1039 7.22177C24.8809 7.43277 24.9469 7.68678 25.1849 7.88178C25.1849 7.88178 25.2289 7.53778 25.2539 7.45978C25.3859 7.55778 25.6649 7.92478 26.0099 7.96378C26.2579 7.96378 26.5049 7.88178 26.7529 7.79978C27.5759 7.71378 29.3929 7.88179 28.9779 9.11579C28.8969 9.36579 28.8129 9.52579 28.6469 9.68979C29.8029 10.1038 28.8129 11.5878 28.5649 12.3268C28.4019 12.9868 28.5159 13.5108 29.3289 13.4288C29.1649 13.7568 28.8969 13.8118 28.5649 13.8118C28.5649 13.8118 28.609 14.0108 28.821 14.1048C28.467 14.4178 28.9419 14.8938 28.7319 15.1278C28.3769 15.2998 27.907 15.0458 27.907 15.0458L27.8839 15.2758C27.8839 15.2758 27.2629 15.2368 27.2479 15.2098C27.2479 15.2098 27.4239 14.8778 27.4129 14.8698C27.2479 15.1198 27.0879 15.2648 26.7529 15.2098C26.7529 15.2098 26.778 15.0578 26.963 14.8578C26.713 15.1078 26.6849 15.2168 26.4229 15.2098C26.4229 14.7998 26.6679 14.3078 27.1639 14.4678C27.2479 14.4678 27.5089 14.6748 27.6299 14.5418C27.7289 14.4008 27.6679 13.9168 27.6679 13.7568C27.7209 13.0268 27.5759 13.0688 27.1639 12.6548C26.8349 12.4088 26.5939 12.0298 26.1819 11.9478C25.7709 11.8658 25.1039 12.3268 24.7739 12.4908C23.9499 12.9868 23.2089 13.3148 22.2999 13.4788C22.2999 13.4788 22.3179 13.4398 22.3179 13.3538C22.3179 13.3028 23.209 12.6078 23.364 11.3888C23.121 12.5918 22.2549 13.2248 22.2219 13.4518C22.1869 13.6708 22.0109 14.0538 21.9899 14.0768C22.0989 14.0138 22.441 13.8468 22.877 13.8108C22.782 14.3228 22.3009 14.2208 22.2189 14.4668C22.2189 14.7168 22.5469 15.0448 22.2189 15.2088H20.8989C20.8989 15.2088 21.1029 14.9278 21.1119 14.8538C20.9329 14.9588 20.8209 15.2448 20.4339 15.2128C20.4489 15.1038 20.6329 14.9398 20.6019 14.8728C20.3779 15.0798 20.2749 15.2558 19.9919 15.2088C20.0739 14.9628 20.0739 14.6348 20.4039 14.6348C20.6509 14.5528 20.8989 14.7168 21.0649 14.4668C21.3949 14.0568 21.0039 13.1538 20.9219 12.6578C20.9219 12.2478 20.9219 12.1698 20.8169 11.6698L20.8989 13.1498C20.5689 12.8998 20.2389 12.7398 19.9919 12.4078C19.4149 11.6698 19.5809 10.8448 20.3219 10.3488C20.6509 10.1028 20.83 9.97379 21.243 9.80979C21.161 9.56379 21.3599 9.37579 21.0679 9.30179C20.9789 9.45379 20.8959 9.62178 20.7269 9.61078L20.8169 9.19678C20.8169 9.19678 20.5189 9.21677 20.5779 9.74777C20.2359 9.58377 20.4039 9.19678 20.4039 9.19678H20.239C20.239 9.19678 20.2379 9.68478 19.9689 9.78278C20.0409 9.55578 20.0739 9.19678 20.0739 9.19678C20.0739 9.19678 19.632 9.72379 19.377 9.55179C19.527 9.37979 19.6439 9.35279 19.6229 9.14579C19.6029 8.94279 19.4959 8.67679 19.4779 8.63379C19.5709 8.68079 20.1929 8.8638 20.5829 8.6688C20.5569 8.8018 20.5679 8.9498 20.5679 8.9498C20.9779 8.8678 21.0639 8.8678 21.4769 9.0278C21.3939 8.4578 21.0639 8.36779 20.7329 7.96179V8.2898C20.4029 8.2078 20.3209 8.12579 20.1549 7.79779L19.9079 7.96179C19.4729 7.70379 19.152 7.09479 19.769 7.12979C20.138 7.17679 19.825 7.46579 19.825 7.46579C19.825 7.46579 20.7699 7.16879 21.1449 7.13779C21.1449 7.13779 21.037 6.90778 20.687 6.86478C20.977 6.64978 21.2679 6.57978 21.4769 7.03678C21.6829 7.05278 21.875 6.79879 21.752 6.47779C22.059 6.47379 22.2089 6.66578 22.3489 6.86878C22.4639 6.88878 22.5779 6.77078 22.5519 6.36078C22.8379 6.60678 22.9819 6.68479 23.0009 6.89179C23.2469 6.94679 23.4139 6.89179 23.7839 6.72779C23.6999 7.05579 23.6999 7.13779 23.3699 7.30579C23.6039 7.59079 23.6299 7.93878 23.5809 8.06378C23.4969 8.04078 23.4769 8.03279 23.4209 8.01679C23.4409 8.14579 23.4649 8.49678 23.4559 8.70478H23.2889L23.5369 9.44678L23.3699 9.68878C23.9489 9.44678 24.5269 9.52478 25.1029 9.36478C25.7629 9.27878 26.4219 9.02878 27.1639 9.02878C27.6589 9.02878 27.6589 9.27878 28.3189 9.27878V8.86878C28.3189 8.54078 28.0719 8.2088 27.6589 8.1268C27.4129 8.1268 26.9989 8.29078 26.7529 8.36878C26.4229 8.45878 25.9269 8.4588 25.5969 8.4588C24.5279 8.2908 24.696 8.18578 24.325 7.98578C24.101 8.04478 23.9749 8.23578 23.8629 8.57178C23.6559 8.26278 23.701 7.8808 23.95 7.7128C23.699 6.8128 24.3589 6.3978 25.1839 6.2338Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M25.4348 13.6476C25.2678 13.3976 24.6898 12.9876 24.8548 12.5736C25.1028 12.1636 26.5058 11.5036 26.7528 12.4096C26.8348 12.6556 26.5788 13.3116 26.4968 13.5616C26.6218 13.5266 26.7618 13.3346 27.1678 13.4056C27.0918 13.7296 26.5968 13.9796 26.5968 13.9796C26.6498 14.1986 26.2578 15.2096 26.2578 15.2096H25.1848L25.3498 14.8816L25.1038 15.2096H24.6908L25.0208 14.7996C25.0208 14.7996 24.6298 15.2566 24.2988 15.2376C24.3778 14.5776 24.7738 14.4676 25.3498 14.7176C25.4348 14.3906 25.5958 13.9766 25.4348 13.6476Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_10"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M24.3149 15.2585L24.2949 15.2545C24.3499 14.6065 24.7189 14.4305 25.3559 14.7035C25.3449 14.6605 25.3589 14.6055 25.3759 14.5475C25.4559 14.2585 25.5509 13.9265 25.4179 13.6565C25.3739 13.5935 25.3059 13.5195 25.2289 13.4375C24.9989 13.1915 24.7119 12.8865 24.8369 12.5665C25.0059 12.2895 25.6459 11.9375 26.1239 11.9375C26.4609 11.9375 26.6839 12.0975 26.7679 12.4065C26.8419 12.6255 26.6599 13.1405 26.5519 13.4495L26.5139 13.5625C26.5269 13.5355 26.5579 13.5155 26.5949 13.4925C26.7039 13.4295 26.8659 13.3365 27.1699 13.3905C27.1069 13.7385 26.6239 13.9845 26.6049 13.9955C26.6649 14.1985 26.2899 15.1715 26.2729 15.2185L25.1829 15.2265L25.3339 14.8715L25.1159 15.2235L24.6879 15.2275L24.8999 14.9305C24.7719 15.0705 24.5349 15.2585 24.3149 15.2585ZM24.9139 14.9185L24.7039 15.2235L25.1019 15.1925L25.3349 14.8725L25.1989 15.2205L26.2559 15.1935C26.2429 15.1935 26.6279 14.1975 26.5769 13.9865C26.5939 13.9635 27.0769 13.7165 27.1489 13.4045C27.0999 13.4165 27.0459 13.4085 26.9969 13.4085C26.8089 13.4085 26.6999 13.4745 26.6129 13.5255C26.5709 13.5525 26.5369 13.5685 26.5009 13.5845L26.5179 13.4395C26.6179 13.1585 26.8029 12.6265 26.7339 12.4195C26.6319 12.0525 26.3459 11.9785 26.1239 11.9785C25.6179 11.9785 25.0129 12.3495 24.8689 12.5835C24.7519 12.8805 25.0289 13.1775 25.2539 13.4115C25.3339 13.4975 25.4039 13.5755 25.4479 13.6385C25.5869 13.9235 25.4929 14.2635 25.4089 14.5605C25.3949 14.6195 25.3789 14.6695 25.3639 14.7205C25.1559 14.6575 24.9929 14.6185 24.8559 14.6185C24.5479 14.6185 24.3709 14.8135 24.3159 15.2235C24.6309 15.2195 25.0009 14.7935 25.0049 14.7895C25.0099 14.8015 24.9739 14.8555 24.9139 14.9185Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_11"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M21.0145 7.44476C20.9055 7.51076 20.9945 7.96476 21.1665 7.88976C21.3785 7.79276 21.1005 7.39476 21.0145 7.44476Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M21.1267 7.91381C21.0637 7.91381 21.0037 7.84782 20.9697 7.72982C20.9367 7.61682 20.9397 7.47179 21.0077 7.42879C21.1177 7.42479 21.2287 7.5738 21.2557 7.7058C21.2767 7.7998 21.2487 7.8698 21.1747 7.9048L21.1267 7.91381ZM21.0327 7.4568C20.9797 7.4838 20.9717 7.6088 21.0037 7.7228C21.0257 7.8008 21.0687 7.8788 21.1267 7.8788V7.89879L21.1597 7.87181C21.2297 7.84081 21.2337 7.76681 21.2207 7.71181C21.1917 7.58581 21.0797 7.4568 21.0327 7.4568Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_13"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M21.1201 7.30469C21.3251 7.44569 21.6471 7.82769 22.0481 7.80469C21.7461 7.55869 21.8071 7.37469 21.8071 7.37469C21.9631 7.56269 22.4911 7.7377 22.6641 7.6637C22.4621 7.5117 22.4221 7.49571 22.3781 7.35471C22.6191 7.38171 22.9201 7.4327 23.1591 7.3317L21.1201 7.30469Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_14"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M21.969 7.80148C21.684 7.80148 21.444 7.59847 21.267 7.44247C21.209 7.39547 21.159 7.35247 21.112 7.31747C21.104 7.30947 21.102 7.30149 21.108 7.29449C21.114 7.28649 21.125 7.28249 21.133 7.29049C21.178 7.32149 21.231 7.36449 21.289 7.41549C21.482 7.58349 21.742 7.80649 22.047 7.79049C21.728 7.56749 21.787 7.38049 21.789 7.37249C21.973 7.54849 22.487 7.72047 22.657 7.64547L22.594 7.63348C22.44 7.52048 22.402 7.49647 22.361 7.36047L22.449 7.34848C22.678 7.37548 22.936 7.41147 23.152 7.31747C22.941 7.44647 22.678 7.41148 22.443 7.38348L22.376 7.37549C22.435 7.47349 22.465 7.4965 22.615 7.6055L22.676 7.6485C22.492 7.7575 21.976 7.58949 21.804 7.40249C21.817 7.44149 21.821 7.59348 22.058 7.79348C22.028 7.79748 21.998 7.80148 21.969 7.80148Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M21.5117 9.8165L21.5347 9.46848C21.5347 9.46848 21.7617 9.99548 21.9267 10.0035C21.8217 9.61648 21.8667 9.3125 21.8667 9.3125L21.5117 9.8165Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_16"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M21.9352 9.9996C21.7472 9.9996 21.5402 9.52659 21.5172 9.47659L21.5302 9.81659C21.5302 9.82859 21.5181 9.82861 21.5111 9.83261C21.5021 9.82861 21.4941 9.82459 21.4941 9.81659L21.5161 9.4686C21.6121 9.6056 21.8002 9.98059 21.9272 9.98459C21.8042 9.62559 21.8451 9.31259 21.8471 9.30859C21.8811 9.31659 21.8382 9.6216 21.9402 9.9996C21.9402 9.9996 21.9392 9.9996 21.9352 9.9996Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_17"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M22.0391 9.3912C22.0391 9.3912 22.4901 10.2192 22.7101 10.0862C22.3781 9.78921 22.416 9.41022 22.416 9.41022C22.416 9.41022 22.564 9.92222 23.011 10.0782C23.04 9.78922 22.8351 9.32422 22.8351 9.32422C22.8351 9.32422 23.2071 9.97222 23.3941 9.98822C23.5131 9.83622 23.4701 9.6752 23.4701 9.6752L22.0391 9.3912Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M22.6479 10.1171C22.6369 10.1171 22.6269 10.1171 22.6149 10.1131C22.3799 10.0501 22.0389 9.42907 22.0239 9.40207C22.0189 9.39007 22.0219 9.38206 22.0319 9.37506C22.0389 9.37506 22.0519 9.37506 22.0549 9.38306C22.0569 9.39106 22.4009 10.0201 22.6239 10.0781C22.6539 10.0861 22.6779 10.0821 22.6979 10.0701C22.3619 9.80007 22.3969 9.41007 22.3969 9.40607C22.4329 9.41007 22.5859 9.90607 23.0149 10.0581C23.0199 9.79607 22.8209 9.33505 22.8189 9.33105C22.8189 9.33105 22.8189 9.33105 22.8189 9.33505C22.8269 9.33505 22.8399 9.35105 22.8569 9.37805C23.0029 9.57305 23.2589 9.95605 23.3919 9.97205C23.4899 9.83505 23.4509 9.68305 23.4499 9.67905H23.4519C23.4859 9.67905 23.5299 9.84305 23.4069 9.99905C23.2529 9.99105 23.0159 9.65105 22.8949 9.46005C22.9639 9.61605 23.0449 9.88606 23.0279 10.0771C22.6409 9.96006 22.4649 9.59305 22.4149 9.46005C22.4349 9.57305 22.4719 9.85106 22.7199 10.0691C22.6989 10.1051 22.6739 10.1171 22.6479 10.1171Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_19"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M21.6846 8.82043L22.0166 9.24243L22.0676 8.67941C22.0676 8.67941 22.3916 8.93342 22.4536 8.92542C22.5126 8.92142 22.3626 8.32343 22.3626 8.32343C22.3626 8.32343 22.8006 8.98744 22.8276 8.97144C22.8576 8.95544 22.8726 8.31543 22.8726 8.31543C22.8726 8.31543 23.2066 9.22544 23.3176 9.22144C23.4306 9.20944 23.4016 9.09244 23.4016 9.09244L21.6846 8.82043Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_20"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M22.0348 9.2464L21.6707 8.8324C21.6657 8.8244 21.6677 8.81639 21.6747 8.80939C21.6817 8.80139 21.6938 8.80139 21.6998 8.81339L22.0298 9.23138L22.0518 8.67639C22.2358 8.78939 22.4157 8.9064 22.4507 8.9104C22.4667 8.8794 22.4108 8.5904 22.3458 8.3284C22.5318 8.5514 22.7948 8.9334 22.8308 8.9574C22.8328 8.9304 22.8487 8.60941 22.8557 8.31641C23.0457 8.74641 23.2597 9.2074 23.3167 9.2034C23.3427 9.1994 23.3618 9.19139 23.3708 9.17639C23.3938 9.14539 23.3838 9.09839 23.3838 9.09839C23.4148 9.08639 23.4338 9.15341 23.4018 9.20041C23.3838 9.22341 23.3568 9.23541 23.3178 9.23941H23.3167C23.1987 9.23941 22.9358 8.54041 22.8578 8.32541C22.8768 8.97041 22.8468 8.98541 22.8368 8.98941C22.8198 8.99741 22.7947 9.0124 22.3477 8.3374C22.4117 8.4504 22.5137 8.87239 22.4767 8.93539C22.3907 8.95539 22.1348 8.75539 22.0578 8.69339L22.0348 9.2464Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M21.4365 8.08606C21.4365 8.08606 21.9475 8.54705 22.0005 8.52005C22.0535 8.49305 21.7905 7.98105 21.7905 7.98105C21.7905 7.98105 22.0835 8.25808 22.1965 8.27808C22.3085 8.30108 22.2355 7.91907 22.2355 7.91907C22.2355 7.91907 22.5825 8.21608 22.6395 8.19608C22.7025 8.18408 22.6705 7.91907 22.6705 7.91907C22.6705 7.91907 22.8955 8.14606 22.9115 8.14606C22.9275 8.14606 22.8635 7.49805 22.8635 7.49805C22.8635 7.49805 23.3675 8.03305 23.4065 8.02505L21.4365 8.08606Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_22"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M21.9986 8.539C21.9266 8.539 21.6486 8.30099 21.4246 8.09799C21.4186 8.08999 21.4156 8.08201 21.4246 8.07101C21.4296 8.06701 21.4436 8.06701 21.4496 8.07101C21.6826 8.28601 21.9496 8.505 21.9956 8.505C22.0046 8.474 21.8906 8.21201 21.7756 7.98901C21.8816 8.04401 22.1106 8.24699 22.1996 8.26199C22.2586 8.21899 22.2376 8.032 22.2166 7.922C22.4066 8.043 22.5936 8.18399 22.6376 8.17999C22.6606 8.17199 22.6676 8.051 22.6536 7.922C22.7866 8.008 22.9006 8.121 22.9186 8.129C22.9026 8.109 22.8716 7.731 22.8486 7.5C23.0626 7.68 23.3696 7.992 23.4096 8.008C23.4026 8.047 23.3646 8.05099 22.8536 7.51199C22.9416 8.13699 22.9306 8.14901 22.9256 8.15701C22.9026 8.16501 22.8897 8.16499 22.6567 7.92999C22.6987 7.99999 22.7116 8.196 22.6456 8.215C22.5856 8.235 22.3196 8.01599 22.2306 7.93799C22.2646 7.98099 22.3046 8.21901 22.2456 8.28201C22.2416 8.28601 22.1986 8.298 22.1926 8.298C22.0746 8.275 21.7906 8.00501 21.7796 7.99301C21.9856 8.32101 22.0546 8.51301 22.0086 8.53601C22.0066 8.53901 22.0046 8.539 21.9986 8.539Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_23"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M19.3896 8.25C19.4136 8.289 19.4966 8.95299 20.5276 8.68399C20.6266 8.62899 20.5836 8.86799 20.5776 8.93799C20.6246 8.92999 21.1156 8.754 21.4546 9.004C21.4146 8.727 21.3406 8.543 21.0486 8.383C20.9016 8.356 20.7996 8.42599 20.7996 8.42599C20.7996 8.42599 19.5556 8.438 19.3896 8.25Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M21.4539 9.02311C21.4499 9.02311 21.4459 9.01911 21.4429 9.01911C21.3269 8.93311 21.1759 8.89011 21.0009 8.89011C20.8289 8.89011 20.6769 8.9291 20.6129 8.9491C20.6079 8.9491 20.5859 8.95311 20.5829 8.94511C20.5769 8.94111 20.5599 8.94111 20.5599 8.93311L20.5639 8.89411C20.5699 8.83511 20.5829 8.71811 20.5599 8.69511C20.3689 8.74211 20.2169 8.76511 20.0829 8.76511C19.7129 8.76511 19.4769 8.60111 19.3829 8.27711C19.3809 8.27311 19.3789 8.26911 19.3789 8.26511C19.5539 8.68711 19.9229 8.82009 20.5239 8.66309L20.5869 8.67109C20.6179 8.70609 20.6119 8.79611 20.6009 8.89411L20.5989 8.93711C20.6719 8.89411 20.8259 8.85111 21.0019 8.85111C21.1699 8.85111 21.3129 8.89009 21.4299 8.96409C21.3919 8.71409 21.3079 8.5461 21.0409 8.4011C21.0229 8.3971 20.9999 8.3931 20.9779 8.3931C20.8799 8.3931 20.8109 8.4401 20.8109 8.4401C20.4849 8.4441 19.5339 8.43211 19.3799 8.26011C19.3799 8.25611 19.3819 8.24809 19.3859 8.24409C19.3929 8.24009 19.4009 8.22809 19.4059 8.23609C19.5179 8.36509 20.2119 8.40809 20.7699 8.40809C20.7849 8.40809 20.8659 8.35709 20.9779 8.35709C21.0019 8.35709 21.0269 8.36109 21.0519 8.36509C21.3539 8.52509 21.4309 8.71308 21.4729 8.99808C21.4729 9.00608 21.4709 9.0141 21.4639 9.0181C21.4609 9.0201 21.4569 9.02311 21.4539 9.02311Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_25"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M18.8297 12.4843C18.8107 12.5623 18.7597 12.5823 18.6047 12.8043C18.6717 12.9023 18.9857 13.0503 19.0727 12.9683C19.1477 12.9293 19.1537 12.7223 19.1537 12.7223C19.3197 12.9683 19.6107 13.3593 19.9407 13.4453C20.1867 13.5233 20.4347 13.3593 20.4347 13.1133C20.4347 12.8633 20.0617 12.4683 19.8977 12.3043C19.4837 11.8083 19.5217 10.8743 18.7407 11.0033C18.7387 11.0113 18.7067 11.1203 18.6327 11.1403C18.6957 11.2573 18.7307 11.3593 18.5807 11.3983C18.6967 11.5113 18.7137 11.5933 18.5637 11.6523C18.6547 11.7733 18.7617 11.8203 18.5527 11.9223C18.7707 12.1373 18.8167 12.4493 18.8297 12.4843Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_26"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M20.071 13.4796C20.024 13.4796 19.98 13.4756 19.935 13.4566C19.689 13.3976 19.432 13.1636 19.154 12.7496C19.169 12.8006 19.152 12.9486 19.082 12.9836C19.065 13.0036 19.037 13.0066 18.999 13.0066C18.87 13.0066 18.648 12.8976 18.59 12.8156C18.657 12.6986 18.705 12.6396 18.741 12.5966C18.783 12.5416 18.804 12.5226 18.811 12.4796C18.787 12.3816 18.73 12.1206 18.542 11.9326C18.614 11.8696 18.65 11.8426 18.655 11.8156C18.66 11.7926 18.634 11.7606 18.599 11.7216C18.583 11.7016 18.568 11.6866 18.549 11.6586C18.614 11.6116 18.646 11.5886 18.653 11.5566C18.66 11.5216 18.632 11.4706 18.568 11.4086C18.621 11.3656 18.65 11.3456 18.66 11.3226C18.68 11.2836 18.657 11.2206 18.616 11.1426C18.666 11.1076 18.697 11.0686 18.723 11.0016C18.791 10.9786 18.837 10.9746 18.882 10.9746C19.305 10.9746 19.449 11.3296 19.604 11.7086C19.69 11.9156 19.776 12.1266 19.911 12.2906C20.074 12.4506 20.454 12.8566 20.454 13.1106C20.453 13.3196 20.285 13.4796 20.071 13.4796ZM19.139 12.7226C19.452 13.1286 19.703 13.3636 19.947 13.4256C20.184 13.5076 20.418 13.3396 20.418 13.1126C20.418 12.8706 20.046 12.4716 19.887 12.3156C19.746 12.1476 19.658 11.9326 19.574 11.7216C19.408 11.3156 19.252 10.9366 18.747 11.0226C18.728 11.0926 18.687 11.1396 18.638 11.1556C18.686 11.1986 18.723 11.2766 18.698 11.3396C18.681 11.3746 18.646 11.3986 18.587 11.4176C18.671 11.4566 18.701 11.5156 18.69 11.5656C18.681 11.6086 18.644 11.6396 18.574 11.6676C18.597 11.6636 18.615 11.6836 18.632 11.6986C18.671 11.7456 18.703 11.7806 18.695 11.8236C18.686 11.8626 18.648 11.8936 18.564 11.9366C18.766 12.0966 18.825 12.3706 18.844 12.4566C18.838 12.5346 18.815 12.5656 18.771 12.6166C18.738 12.6596 18.689 12.7216 18.623 12.8156C18.687 12.8786 19 13.0146 19.064 12.9566C19.121 12.9256 19.137 12.7766 19.139 12.7226Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M18.6268 5.50391C18.3768 5.86291 18.3518 9.81692 18.4318 10.6089C18.1808 10.7729 17.7188 10.7069 17.5908 10.6559C17.6508 10.3709 17.8648 5.78891 18.6268 5.50391Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_28"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask27_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M17.994 10.7303C17.824 10.7303 17.659 10.6993 17.584 10.6713C17.584 10.6013 17.602 10.3983 17.623 10.1243C17.733 8.8043 17.987 5.7223 18.619 5.4873C18.398 5.8663 18.365 9.76831 18.446 10.6083C18.308 10.7113 18.124 10.7303 17.994 10.7303ZM18.612 5.49631C18.02 5.74631 17.759 8.92631 17.659 10.1253C17.636 10.4143 17.619 10.6053 17.608 10.6603C17.667 10.6643 17.829 10.6953 17.994 10.6953C18.12 10.6953 18.295 10.6793 18.42 10.5973C18.342 9.89529 18.354 5.86731 18.612 5.49631Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_29"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M17.925 13.6054C17.925 13.6054 16.83 13.7574 17.291 13.1094C17.686 12.9374 17.676 13.3394 17.53 13.4764C17.711 13.4964 17.829 13.3824 17.856 13.2034C17.633 12.9024 17.951 12.7074 17.933 12.7074C17.171 12.8794 17.07 12.3554 17.349 12.2734C17.708 12.2934 17.594 12.4064 17.737 12.5114C17.992 12.2734 18.147 12.2494 18.301 12.4914C18.456 12.2534 18.677 12.2804 18.686 12.3034C18.934 12.7254 18.386 12.7484 18.166 12.6984C18.353 12.9014 18.276 13.1004 18.216 13.2454C18.223 13.3904 18.331 13.4094 18.507 13.4684C18.13 12.4294 19.833 13.7454 18.121 13.6134C18.125 13.6604 18.129 13.7074 18.13 13.7504C18.271 13.7774 18.368 13.8094 18.414 13.9574C18.353 14.0354 18.261 14.0474 18.114 13.9924C18.114 13.9924 18.2 14.2304 18.044 14.2974C17.917 14.2194 17.9 14.0354 17.9 14.0354C17.828 14.1214 17.723 14.0624 17.634 13.9924C17.714 13.7934 17.938 13.8874 17.925 13.6054Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M16.9836 10.4409C17.0496 10.1439 17.7376 10.1789 17.4096 10.4999C17.6316 10.8519 18.3046 10.8009 18.5556 10.6019C18.3426 10.1959 18.9226 10.2859 18.8986 10.5939C18.8276 11.1449 16.9086 11.0699 16.9836 10.4409Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_31"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask30_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M29.6289 15.6914C29.8339 16.0784 30.1989 16.9844 30.4009 17.2034C30.5929 17.3714 31.0629 17.3514 31.2079 17.1604C31.2079 17.1604 31.5109 17.4734 31.6329 17.5664C31.7049 17.5394 31.7489 17.4724 31.7489 17.4724C31.6269 17.3394 31.4599 17.2614 31.3769 17.0154C31.4979 16.8514 31.5689 16.5314 31.4829 16.2854C31.1239 15.6804 29.9239 15.9184 29.6289 15.6914Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_32"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M31.6293 17.5902L31.6203 17.5822C31.4983 17.4882 31.2063 17.1872 31.1933 17.1762C31.1033 17.3562 30.5753 17.3872 30.3873 17.2152C30.2523 17.0702 30.0493 16.6292 29.8683 16.2352C29.7713 16.0282 29.6823 15.8292 29.6123 15.7002C29.7423 15.7592 29.9763 15.7782 30.2463 15.8022C30.7033 15.8412 31.2673 15.8922 31.4973 16.2792C31.5863 16.5412 31.5103 16.8652 31.3893 17.0292C31.4513 17.1852 31.5503 17.2712 31.6483 17.3572C31.6883 17.3882 31.7263 17.4232 31.7623 17.4622C31.7623 17.4892 31.7133 17.5602 31.6353 17.5872L31.6293 17.5902ZM31.1923 17.1482C31.2203 17.1522 31.5083 17.4492 31.6333 17.5462C31.6963 17.5192 31.7323 17.4602 31.7323 17.4602C31.6993 17.4482 31.6633 17.4132 31.6253 17.3822C31.5233 17.2922 31.4193 17.2022 31.3583 17.0232C31.4763 16.8512 31.5503 16.5392 31.4673 16.2892C31.2473 15.9262 30.6913 15.8752 30.2453 15.8362C29.9683 15.8132 29.7283 15.7932 29.6163 15.7032C29.7163 15.8162 29.8063 16.0122 29.9003 16.2192C30.0783 16.6102 30.2813 17.0512 30.4113 17.1922C30.5833 17.3402 31.0633 17.3162 31.1923 17.1482Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M16.7469 5.19531C16.5429 4.81231 16.1769 3.89829 15.9749 3.67929C15.7859 3.51129 15.3139 3.53129 15.1679 3.72229C15.1679 3.72229 14.8649 3.41331 14.7449 3.32031C14.6719 3.34331 14.627 3.41431 14.627 3.41431C14.751 3.54331 14.9179 3.62131 14.9999 3.87131C14.8769 4.03531 14.8099 4.35132 14.8909 4.60132C15.2539 5.20332 16.4529 4.96531 16.7469 5.19531Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_34"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask33_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M16.7362 5.20679C16.6312 5.12879 16.3983 5.10478 16.1273 5.08578C15.6743 5.04278 15.1063 4.9918 14.8773 4.6088C14.7903 4.3428 14.8652 4.0228 14.9852 3.8588C14.9262 3.7028 14.8253 3.61279 14.7263 3.53079C14.6883 3.49579 14.6482 3.46478 14.6152 3.42578C14.6152 3.39878 14.6612 3.32778 14.7402 3.30078C14.8772 3.39878 15.1692 3.69878 15.1812 3.71078C15.2722 3.53078 15.8023 3.50379 15.9883 3.66779C16.1223 3.81279 16.3262 4.2578 16.5052 4.6478C16.6022 4.8548 16.6933 5.0538 16.7643 5.1868L16.7362 5.20679ZM14.7343 3.33179C14.6843 3.35879 14.6412 3.42178 14.6412 3.42578C14.6732 3.43778 14.7122 3.47278 14.7502 3.50378C14.8512 3.58978 14.9542 3.67979 15.0172 3.86279C14.8982 4.03479 14.8272 4.34277 14.9092 4.59277C15.1292 4.95977 15.6853 5.01078 16.1313 5.04578C16.3673 5.06578 16.5762 5.0888 16.7032 5.1478C16.6372 5.0148 16.5572 4.84279 16.4732 4.66379C16.2942 4.27279 16.0932 3.8318 15.9612 3.6908C15.7942 3.5428 15.3103 3.5698 15.1823 3.7338C15.1533 3.7338 14.8533 3.42579 14.7343 3.33179Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_35"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M16.626 15.6289C16.241 15.8359 15.33 16.2029 15.112 16.4019C14.942 16.5929 14.963 17.0659 15.155 17.2109C15.155 17.2109 14.842 17.5119 14.749 17.6369C14.773 17.7069 14.843 17.7539 14.843 17.7539C14.977 17.6289 15.052 17.4609 15.3 17.3789C15.466 17.4999 15.783 17.5699 16.03 17.4879C16.635 17.1289 16.396 15.9259 16.626 15.6289Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M14.8445 17.7732L14.8335 17.7652C14.8295 17.7652 14.7584 17.7182 14.7314 17.6402C14.8274 17.4992 15.1294 17.2102 15.1414 17.1992C15.0554 17.1602 14.9964 17.0272 14.9804 16.8632C14.9634 16.6752 15.0074 16.4922 15.0964 16.3902C15.2424 16.2572 15.6855 16.0502 16.0745 15.8742C16.2865 15.7762 16.4834 15.6862 16.6154 15.6162C16.5564 15.7492 16.5354 15.9792 16.5114 16.2532C16.4724 16.7062 16.4244 17.2732 16.0364 17.4992C15.9604 17.5262 15.8785 17.5382 15.7895 17.5382C15.6035 17.5382 15.4074 17.4832 15.2864 17.3902C15.1314 17.4532 15.0434 17.5542 14.9604 17.6522C14.9244 17.6912 14.8905 17.7302 14.8535 17.7652L14.8445 17.7732ZM16.6115 15.6212C16.5015 15.7192 16.3015 15.8092 16.0915 15.9062C15.7025 16.0822 15.2624 16.2852 15.1234 16.4182C15.0414 16.5082 15.0004 16.6842 15.0164 16.8592C15.0314 17.0112 15.0855 17.1362 15.1645 17.1992C15.1625 17.2262 14.8534 17.5272 14.7614 17.6442C14.7814 17.6832 14.8205 17.7142 14.8405 17.7302C14.8735 17.6952 14.9045 17.6642 14.9325 17.6282C15.0225 17.5262 15.1095 17.4212 15.2935 17.3582C15.4845 17.4912 15.8064 17.5422 16.0234 17.4672C16.3904 17.2482 16.4374 16.6942 16.4764 16.2482C16.5014 15.9732 16.5215 15.7342 16.6115 15.6212Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_37"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask36_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M29.6611 5.19531C29.8661 4.81231 30.2321 3.89829 30.4331 3.67929C30.6221 3.51129 31.0941 3.53129 31.2401 3.72229C31.2401 3.72229 31.5431 3.41331 31.6641 3.32031C31.7361 3.34331 31.7821 3.41431 31.7821 3.41431C31.6591 3.54331 31.4881 3.62131 31.4081 3.87131C31.5301 4.03531 31.5981 4.35132 31.5151 4.60132C31.1551 5.20332 29.9551 4.96531 29.6611 5.19531Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_38"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M29.6715 5.20673L29.6436 5.18674C29.7176 5.05374 29.8086 4.85474 29.9026 4.64774C30.0846 4.25674 30.2875 3.81172 30.4215 3.67072C30.6105 3.50272 31.1136 3.52572 31.2556 3.70972C31.2446 3.68972 31.5325 3.39671 31.6535 3.30371C31.7485 3.32671 31.7955 3.39773 31.7975 3.40173C31.7595 3.46473 31.7195 3.49573 31.6835 3.53073C31.5845 3.61273 31.4825 3.70273 31.4255 3.87473C31.5455 4.02273 31.6215 4.34774 31.5335 4.60474C31.3005 4.99174 30.7366 5.04272 30.2816 5.08472C30.0106 5.10472 29.7765 5.12473 29.6715 5.20673ZM30.8135 3.58173C30.6595 3.58173 30.5216 3.62473 30.4456 3.69473C30.3146 3.83173 30.1135 4.27273 29.9335 4.66373C29.8485 4.84373 29.7705 5.01574 29.7055 5.14374C29.8325 5.08874 30.0425 5.06572 30.2755 5.04572C30.7235 5.00672 31.2785 4.95971 31.4995 4.58871C31.5825 4.34271 31.5085 4.03371 31.3925 3.88171C31.4505 3.67871 31.5555 3.58872 31.6555 3.50272C31.6935 3.47172 31.7295 3.43973 31.7625 3.40073C31.7495 3.40073 31.7115 3.34972 31.6585 3.33072C31.5545 3.42472 31.2555 3.73273 31.2525 3.73273C31.1545 3.64473 30.9925 3.58173 30.8135 3.58173Z",
    fill: "#8E1841"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_39"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M17.2927 11.1172C17.2757 11.2382 17.5757 11.2972 17.8837 11.2972C18.1887 11.3012 18.5017 11.2462 18.5167 11.1602C18.5197 11.0042 18.2487 11.1402 17.9397 11.1372C17.6317 11.1372 17.3727 11.0122 17.2927 11.1172Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_40"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask39_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    d: "M17.8944 11.3156H17.8824C17.7704 11.3156 17.3985 11.3036 17.2985 11.1906C17.2785 11.1676 17.2704 11.1396 17.2744 11.1126C17.3304 11.0386 17.4424 11.0536 17.6094 11.0816C17.7084 11.0976 17.8204 11.1166 17.9384 11.1206C18.0544 11.1206 18.1604 11.1006 18.2504 11.0896C18.3814 11.0666 18.4754 11.0586 18.5124 11.0936C18.5294 11.1136 18.5354 11.1366 18.5344 11.1636C18.5144 11.2846 18.1084 11.3156 17.8944 11.3156ZM17.4094 11.0896C17.3584 11.0896 17.3244 11.1016 17.3044 11.1286C17.3084 11.1366 17.3114 11.1486 17.3254 11.1636C17.3854 11.2336 17.5974 11.2766 17.8824 11.2806L17.8944 11.2966V11.2806C18.2444 11.2806 18.4884 11.2146 18.4974 11.1596C18.4994 11.1396 18.4934 11.1326 18.4864 11.1206C18.4604 11.0936 18.3695 11.1006 18.2555 11.1246C18.1645 11.1406 18.0594 11.1516 17.9484 11.1516C17.8164 11.1516 17.7025 11.1356 17.6045 11.1166C17.5295 11.1016 17.4634 11.0896 17.4094 11.0896Z",
    fill: "#F5CD28"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_41"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    d: "M17.3154 11.4654C17.3214 11.5824 17.6164 11.6104 17.8794 11.6174C18.1424 11.6254 18.4064 11.5744 18.4554 11.4884C18.4084 11.3554 18.1174 11.4654 17.8794 11.4724C17.6424 11.4804 17.3784 11.3554 17.3154 11.4654Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M17.9338 11.6373H17.8798C17.6108 11.6253 17.3038 11.5983 17.2988 11.4653C17.3288 11.4063 17.3868 11.4023 17.4248 11.4023C17.4768 11.4023 17.5388 11.4143 17.6088 11.4223C17.6898 11.4423 17.7778 11.4533 17.8628 11.4533C17.9548 11.4493 18.0358 11.4413 18.1118 11.4303C18.1868 11.4183 18.2598 11.4073 18.3188 11.4073C18.3738 11.4073 18.4488 11.4153 18.4738 11.4853C18.4168 11.5943 18.1538 11.6373 17.9338 11.6373ZM17.4248 11.4383C17.3768 11.4383 17.3468 11.4463 17.3328 11.4733C17.3378 11.5433 17.5208 11.5903 17.8818 11.5983L17.9338 11.6023C18.1798 11.6023 18.4028 11.5473 18.4418 11.4813C18.4158 11.4423 18.2828 11.4383 18.1178 11.4613C18.0398 11.4773 17.9568 11.4883 17.8808 11.4923C17.7898 11.5043 17.6848 11.4763 17.6028 11.4613C17.5358 11.4453 17.4748 11.4383 17.4248 11.4383Z",
    fill: "#F5CD28"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_43"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask42_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    d: "M17.4005 11.7768C17.3805 11.8628 17.6415 11.9248 17.8825 11.9288C18.1225 11.9288 18.4655 11.8388 18.4675 11.7408C18.4525 11.6668 18.1155 11.7678 17.8895 11.7758C17.6635 11.7848 17.4005 11.6948 17.4005 11.7768Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_44"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    d: "M17.8906 11.9453H17.8836C17.6936 11.9453 17.4586 11.9023 17.3986 11.8283C17.3866 11.8083 17.3816 11.7933 17.3846 11.7733C17.3846 11.7223 17.4476 11.7223 17.4696 11.7223C17.5086 11.7223 17.5606 11.7303 17.6186 11.7383C17.6936 11.7503 17.7766 11.7583 17.8596 11.7583C17.9756 11.7583 18.0756 11.7423 18.1696 11.7233C18.2596 11.7113 18.3396 11.6963 18.3946 11.6963C18.4186 11.6963 18.4796 11.6963 18.4856 11.7433C18.4826 11.8593 18.1216 11.9453 17.8906 11.9453ZM17.4696 11.7583C17.4356 11.7583 17.4196 11.7623 17.4196 11.7783C17.4716 11.8643 17.6756 11.9113 17.8856 11.9113L17.8906 11.9313V11.9113C18.1346 11.9113 18.4486 11.8173 18.4506 11.7433C18.4486 11.7393 18.3246 11.7393 18.1766 11.7633C18.0816 11.7753 17.9796 11.7943 17.8916 11.7943C17.7666 11.7943 17.6916 11.7863 17.6166 11.7743C17.5576 11.7663 17.5066 11.7583 17.4696 11.7583Z",
    fill: "#F5CD28"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_11472_43019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M17.3731 12.0982C17.3931 12.1842 17.6901 12.2112 17.9511 12.1922C18.2141 12.1722 18.4791 12.0942 18.5001 11.9972C18.4871 11.9382 18.1881 12.0442 17.9391 12.0562C17.6921 12.0702 17.3701 12.0232 17.3731 12.0982Z",
    fill: "#F5CD28"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_46"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask45_11472_43019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 34,
    height: 21
  }, _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_00000001622334996559933170000017477739389023352719__41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M33.5728 0.664062H0.00976562V20.2461H33.5728V0.664062Z",
    fill: "white"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_11472_43019)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M17.7954 12.2149C17.6974 12.2149 17.3804 12.2029 17.3574 12.0979C17.3864 12.0469 17.4414 12.0349 17.5534 12.0349L17.8264 12.0389C17.8644 12.0389 17.9014 12.0389 17.9374 12.0349C18.0434 12.0309 18.1604 12.0119 18.2584 11.9919C18.3404 11.9759 18.4094 11.9609 18.4544 11.9609C18.4674 11.9609 18.5094 11.9609 18.5174 11.9959C18.4904 12.1089 18.2064 12.1909 17.9514 12.2069C17.9004 12.2109 17.8474 12.2149 17.7954 12.2149ZM17.5534 12.0699C17.4584 12.0699 17.4034 12.0779 17.3904 12.0929C17.4014 12.1359 17.5424 12.1789 17.7954 12.1789C17.8474 12.1789 17.8994 12.1749 17.9504 12.1709C18.2184 12.1509 18.4644 12.0689 18.4824 11.9949C18.4124 11.9949 18.3434 12.0109 18.2654 12.0219C18.1644 12.0449 18.0454 12.0649 17.9384 12.0689C17.9034 12.0729 17.8644 12.0729 17.8264 12.0729L17.5534 12.0699Z",
    fill: "#F5CD28"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSriLanka);
export default __webpack_public_path__ + "static/media/SRI_LANKA.6c7e8647a4d912f16d5edae409e62011.svg";
export { ForwardRef as ReactComponent };